/* Clipz-it (27/10/2026). Notre code. Page « Suivre ma commande » : appelle le service de suivi (lecture seule)
   et affiche le résultat dans la langue de la page. Les étapes arrivent en codes ; aucun texte de transporteur n'est affiché. */
(function () {
  var racine = document.getElementById('cz-suivi');
  if (!racine) return;
  // Shopify encode les textes traduits (apostrophes en &#39;) : on les décode avant de les échapper nous-mêmes
  var deco = document.createElement('textarea');
  var decoder = function (v) {
    if (typeof v === 'string') { deco.innerHTML = v; return deco.value; }
    if (Array.isArray(v)) return v.map(decoder);
    if (v && typeof v === 'object') { var o = {}; for (var k in v) o[k] = decoder(v[k]); return o; }
    return v;
  };
  var T = decoder(JSON.parse(document.getElementById('cz-suivi-textes').textContent));
  var api = racine.getAttribute('data-api');
  var lang = racine.getAttribute('data-lang') || document.documentElement.lang || 'fr';
  var form = racine.querySelector('form[data-mode="numero"]');
  var formEmail = racine.querySelector('form[data-mode="email"]');
  var champ = racine.querySelector('#cz-suivi-n');
  var bouton = form.querySelector('.cz-suivi__bouton');
  var zone = racine.querySelector('.cz-suivi__resultat');

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var remplir = function (t, v) { return String(t).replace(/\[(\w+)\]/g, function (_, k) { return v[k] != null ? v[k] : ''; }); };
  var date = function (iso, o) { try { return new Intl.DateTimeFormat(lang, o).format(new Date(iso.length === 10 ? iso + 'T12:00:00' : iso)); } catch (e) { return iso; } };
  var jourMois = function (iso) { return date(iso, { weekday: 'long', day: 'numeric', month: 'long' }); };
  var court = function (iso) { return date(iso, { day: 'numeric', month: 'short' }) + ' · ' + date(iso, { hour: '2-digit', minute: '2-digit' }); };
  var pays = function (cc) { try { return new Intl.DisplayNames([lang], { type: 'region' }).of(cc); } catch (e) { return cc; } };

  function message(titre, texte) {
    zone.innerHTML = '<div class="cz-suivi__message" role="status">' + (titre ? '<strong>' + esc(titre) + '</strong>' : '') + esc(texte) + '</div>';
  }

  function afficher(d) {
    var st = d.statut;
    var html = '<div class="cz-suivi__carte cz-suivi--' + esc(st) + '">';
    html += '<div class="cz-suivi__tete"><div>';
    if (d.commande) html += '<p class="cz-suivi__cmd">' + esc(remplir(T.commande, { numero: '#' + d.commande, date: d.commande_le ? date(d.commande_le, { day: 'numeric', month: 'long' }) : '' })) + '</p>';
    html += '<h2 class="cz-suivi__statut">' + esc(T.st[st] || st) + '</h2>';
    if (d.livree_le) html += '<p class="cz-suivi__eta">' + esc(remplir(T.livree_le, { date: jourMois(d.livree_le) })) + '</p>';
    else if (d.estimation) html += '<p class="cz-suivi__eta">' + remplir(esc(T.estimation), { du: '<b>' + esc(jourMois(d.estimation.du)) + '</b>', au: '<b>' + esc(jourMois(d.estimation.au)) + '</b>' }) + '</p>';
    html += '</div>';
    if (d.transporteur) {
      var tr = d.transporteur;
      html += '<div class="cz-suivi__transp"><small>' + esc(T.transporteur) + '</small><strong>' + esc(tr.nom) + '</strong>' +
        '<span class="cz-suivi__num">' + esc(T.numero) + ' <a href="' + esc(tr.site) + '" target="_blank" rel="noopener nofollow">' + esc(tr.numero) + '</a>' +
        '<button type="button" class="cz-suivi__copier" data-copie="' + esc(tr.numero) + '">' + esc(T.copier) + '</button></span></div>';
    }
    html += '</div><ol class="cz-suivi__barre">';
    T.etapes.forEach(function (e, i) { html += '<li class="' + (i <= d.etape ? 'fait' : '') + '"' + (i === d.etape ? ' aria-current="step"' : '') + '>' + esc(e) + '</li>'; });
    html += '</ol>';
    var x = T.x[st];
    if (x) html += '<div class="cz-suivi__encart cz-suivi__encart--' + esc(st) + '"><strong>' + esc(x[0]) + '</strong>' + esc(x[1]) + '</div>';
    if (d.historique && d.historique.length) {
      html += '<ol class="cz-suivi__histo">';
      d.historique.forEach(function (h) {
        var lieu = h.ville ? h.ville + (d.pays ? ', ' + pays(d.pays) : '') : '';
        html += '<li><b>' + esc(T.h[h.code] || h.code) + '</b><time datetime="' + esc(h.t) + '">' + esc(court(h.t)) + '</time>' + (lieu ? '<span>' + esc(lieu) + '</span>' : '') + '</li>';
      });
      html += '</ol>';
    }
    zone.innerHTML = html + '</div>';
    var c = zone.querySelector('.cz-suivi__copier');
    if (c) c.addEventListener('click', function () {
      try { navigator.clipboard.writeText(c.getAttribute('data-copie')); c.textContent = T.copie; setTimeout(function () { c.textContent = T.copier; }, 1800); } catch (e) {}
    });
  }

  function attendre(b) { b.disabled = true; zone.innerHTML = '<div class="cz-suivi__message cz-suivi__charge">' + esc(T.chargement) + '</div>'; }
  function lire(promesse, b, pasTrouve) {
    promesse
      .then(function (r) { if (r.status === 429) throw new Error('trop'); if (!r.ok) throw new Error('erreur'); return r.json(); })
      .then(function (d) { if (d && d.trouve) afficher(d); else message(pasTrouve[0], pasTrouve[1]); })
      .catch(function (e) { message('', e.message === 'trop' ? T.trop : T.erreur); })
      .then(function () { b.disabled = false; });
  }

  function chercher(n) {
    n = String(n || '').trim();
    if (!n) { champ.focus(); return; }
    attendre(bouton);
    try { var u = new URL(location.href); u.searchParams.set('n', n); history.replaceState(null, '', u); } catch (e) {}
    lire(fetch(api + '?n=' + encodeURIComponent(n), { headers: { Accept: 'application/json' } }), bouton, T.inconnu);
  }

  // Sans numéro de suivi : e-mail + numéro de commande ou code postal, envoyés dans le corps (jamais dans l'adresse)
  formEmail.addEventListener('submit', function (e) {
    e.preventDefault();
    var b = formEmail.querySelector('.cz-suivi__bouton');
    var email = formEmail.querySelector('#cz-suivi-email'), ref = formEmail.querySelector('#cz-suivi-ref');
    if (!email.value.trim()) { email.focus(); return; }
    if (!ref.value.trim()) { ref.focus(); return; }
    attendre(b);
    try { var u = new URL(location.href); u.searchParams.delete('n'); history.replaceState(null, '', u); } catch (x) {}
    lire(fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams({ email: email.value.trim(), ref: ref.value.trim() }) }), b, T.commande_inconnue);
  });
  racine.querySelectorAll('.cz-suivi__bascule').forEach(function (b) {
    b.addEventListener('click', function () {
      var vers = b.getAttribute('data-vers');
      form.hidden = vers !== 'numero'; formEmail.hidden = vers !== 'email'; zone.innerHTML = '';
      var intro = racine.querySelector('.cz-suivi__intro');
      if (intro) intro.textContent = decoder(intro.getAttribute(vers === 'email' ? 'data-email' : 'data-numero') || intro.textContent);
      (vers === 'email' ? formEmail.querySelector('#cz-suivi-email') : champ).focus();
    });
  });

  form.addEventListener('submit', function (e) { e.preventDefault(); chercher(champ.value); });
  // Lien direct depuis un e-mail : /pages/suivi?n=NUMERO
  var depart = new URLSearchParams(location.search).get('n');
  if (depart) { champ.value = depart; chercher(depart); }
})();
